import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Badge, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Get } from '../../../../utils/httpProvider';
import { LICHHOCTHUCHANH_API } from '../../../../utils/apiUrl';

const AttendanceReportTab = ({ contractId }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);

    // Modal chi tiết của 1 học viên
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);

    useEffect(() => {
        if (contractId) {
            fetchReport();
        }
    }, [contractId]);

    const fetchReport = async () => {
        setLoading(false);
        setLoading(true);
        try {
            const res = await Get(`${LICHHOCTHUCHANH_API.BAO_CAO_DIEM_DANH}/${contractId}`);
            const data = res?.$values || res || [];
            setReportData(data);
        } catch (err) {
            toast.error("Không thể tải báo cáo điểm danh thực tế.");
        } finally {
            setLoading(false);
        }
    };

    const handleOpenDetail = (student) => {
        setSelectedStudent(student);
        setShowDetailModal(true);
    };

    const handleExportCsv = () => {
        if (reportData.length === 0) {
            toast.info("Không có dữ liệu điểm danh để xuất báo cáo.");
            return;
        }

        setIsExporting(true);
        try {
            let csvContent = "\ufeff"; // BOM utf-8
            csvContent += "Họ và tên,Tổng số buổi,Số buổi có mặt,Vắng có phép,Vắng không phép,Chi tiết ngày học,GV Kế hoạch,GV Thực tế,Trạng thái học,Loại hình,Lý do điều phối\n";

            reportData.forEach(item => {
                const chiTietList = item.chiTiet?.$values || item.chiTiet || [];
                if (chiTietList.length === 0) {
                    csvContent += `"${item.hocVienTen}",${item.tongSoBuoi},${item.soBuoiCoMat},${item.soBuoiVangCoPhep},${item.soBuoiVangKhongPhep},"N/A","N/A","N/A","N/A","N/A","N/A"\n`;
                } else {
                    chiTietList.forEach(ct => {
                        csvContent += `"${item.hocVienTen}",${item.tongSoBuoi},${item.soBuoiCoMat},${item.soBuoiVangCoPhep},${item.soBuoiVangKhongPhep},"${ct.ngayHocStr}","${ct.gvlsKeHoach}","${ct.gvlsThucTe}","${ct.trangThaiText}","${ct.loaiHinhText}","${ct.lyDoDieuPhoi || ''}"\n`;
                    });
                }
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', `bao_cao_diem_danh_thuc_te_khoa_${contractId}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success("Xuất file báo cáo thành công.");
        } catch (err) {
            toast.error("Gặp sự cố khi kết xuất báo cáo.");
        } finally {
            setIsExporting(false);
        }
    };

    const getTrangThaiBadge = (trangThai) => {
        const baseStyle = {
            padding: '6px 12px',
            fontSize: '0.8rem',
            fontWeight: '600',
            borderRadius: '4px',
            display: 'inline-block'
        };

        switch (trangThai) {
            case 1:
                return <Badge bg="success" style={{ ...baseStyle, backgroundColor: '#28a745', color: '#ffffff' }}>Có mặt</Badge>;
            case 2:
                return <Badge bg="primary" style={{ ...baseStyle, backgroundColor: '#007bff', color: '#ffffff' }}>Có mặt (Ngoài lịch)</Badge>;
            case 3:
                return <Badge bg="warning" style={{ ...baseStyle, backgroundColor: '#ffc107', color: '#212529' }}>Vắng có phép</Badge>;
            case 4:
                return <Badge bg="danger" style={{ ...baseStyle, backgroundColor: '#dc3545', color: '#ffffff' }}>Vắng không phép</Badge>;
            case 5:
                return <Badge bg="secondary" style={{ ...baseStyle, backgroundColor: '#6c757d', color: '#ffffff' }}>Học buổi khác</Badge>;
            default:
                return <span className="text-muted small">Chưa điểm danh</span>;
        }
    };

    return (
        <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h5 className="font-weight-bold text-dark mb-1">Báo cáo tổng hợp điểm danh thực tế</h5>
                    <div className="text-muted small">Thông kê chuyên cần lâm sàng và lịch sử điều phối thực tế của học viên</div>
                </div>
                <div className="d-flex align-items-center">
                    <Button
                        variant="light"
                        size="sm"
                        className="mr-2 border"
                        onClick={fetchReport}
                        disabled={loading}
                        style={{ borderRadius: '8px', padding: '8px 16px' }}
                    >
                        <i className={`fas fa-sync-alt mr-2 ${loading ? 'fa-spin' : ''}`}></i> Làm mới
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        onClick={handleExportCsv}
                        disabled={loading || isExporting}
                        style={{ borderRadius: '8px', padding: '8px 16px', fontWeight: 'bold' }}
                    >
                        <i className="fas fa-file-download mr-2"></i> {isExporting ? 'Đang xuất...' : 'Xuất báo cáo toàn khóa'}
                    </Button>
                </div>
            </div>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary spinner-border-sm mr-2" role="status"></div>
                    <span className="text-muted font-weight-bold">Đang tổng hợp dữ liệu điểm danh thực tế...</span>
                </div>
            ) : reportData.length > 0 ? (
                <div className="table-responsive rounded-lg border bg-white">
                    <Table striped hover className="mb-0 align-middle" style={{ fontSize: '0.9rem' }}>
                        <thead className="bg-light font-weight-bold">
                            <tr>
                                <th style={{ width: '60px' }} className="text-center">STT</th>
                                <th>Họ và tên học viên</th>
                                <th className="text-center" style={{ width: '150px' }}>Tổng số buổi</th>
                                <th className="text-center" style={{ width: '130px' }}>Số buổi đi học</th>
                                <th className="text-center" style={{ width: '130px' }}>Vắng phép</th>
                                <th className="text-center" style={{ width: '130px' }}>Vắng không phép</th>
                                <th className="text-center" style={{ width: '130px' }}>Tỷ lệ tham gia</th>
                                <th className="text-center" style={{ width: '120px' }}>Hành động</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.map((std, index) => {
                                const attendanceRate = std.tongSoBuoi > 0
                                    ? Math.round((std.soBuoiCoMat / std.tongSoBuoi) * 100)
                                    : 0;
                                return (
                                    <tr key={index}>
                                        <td className="text-center text-muted">{index + 1}</td>
                                        <td className="font-weight-bold text-dark">{std.hocVienTen}</td>
                                        <td className="text-center font-weight-bold text-secondary">{std.tongSoBuoi}</td>
                                        <td className="text-center font-weight-bold text-success">{std.soBuoiCoMat}</td>
                                        <td className="text-center font-weight-bold text-warning">{std.soBuoiVangCoPhep}</td>
                                        <td className="text-center font-weight-bold text-danger">{std.soBuoiVangKhongPhep}</td>
                                        <td className="text-center font-weight-bold">
                                            <span className={`badge ${attendanceRate >= 80 ? 'bg-success' : attendanceRate >= 50 ? 'bg-warning text-dark' : 'bg-danger'}`}>
                                                {attendanceRate}%
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                style={{ borderRadius: '6px' }}
                                                onClick={() => handleOpenDetail(std)}
                                            >
                                                <i className="fas fa-eye mr-1"></i> Chi tiết
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            ) : (
                <div className="text-center py-5 text-muted border rounded-lg bg-light">
                    <i className="fas fa-clipboard-list fa-3x mb-3 text-muted" style={{ opacity: 0.5 }}></i>
                    <h5>Chưa có dữ liệu điểm danh thực tế</h5>
                    <p className="small mb-0">Hệ thống sẽ tổng hợp số liệu chuyên cần ngay sau khi các giảng viên thực hiện điểm danh.</p>
                </div>
            )}

            {/* MODAL XEM CHI TIẾT NHẬT KÝ ĐIỂM DANH HỌC VIÊN */}
            <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="font-weight-bold text-primary small text-uppercase">
                        <i className="fas fa-user-clock mr-2"></i> Nhật ký đi học: {selectedStudent?.hocVienTen}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-light">
                    <div className="d-flex justify-content-around mb-3">
                        <Card className="text-center p-2 border-0 shadow-sm flex-fill mx-1">
                            <span className="text-muted small">Có mặt</span>
                            <h4 className="mb-0 text-success font-weight-bold">{selectedStudent?.soBuoiCoMat}</h4>
                        </Card>
                        <Card className="text-center p-2 border-0 shadow-sm flex-fill mx-1">
                            <span className="text-muted small">Vắng phép</span>
                            <h4 className="mb-0 text-warning font-weight-bold">{selectedStudent?.soBuoiVangCoPhep}</h4>
                        </Card>
                        <Card className="text-center p-2 border-0 shadow-sm flex-fill mx-1">
                            <span className="text-muted small">Vắng KP</span>
                            <h4 className="mb-0 text-danger font-weight-bold">{selectedStudent?.soBuoiVangKhongPhep}</h4>
                        </Card>
                    </div>

                    <div className="table-responsive bg-white rounded border">
                        <Table hover className="mb-0 align-middle" style={{ fontSize: '0.85rem' }}>
                            <thead className="bg-light font-weight-bold">
                                <tr>
                                    <th style={{ width: '50px' }} className="text-center">STT</th>
                                    <th>Ngày học</th>
                                    <th>GV Kế hoạch</th>
                                    <th>GV Thực tế dạy</th>
                                    <th>Loại hình</th>
                                    <th>Trạng thái</th>
                                    <th>Lý do điều phối</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    const details = selectedStudent?.chiTiet?.$values || selectedStudent?.chiTiet || [];
                                    if (details.length === 0) {
                                        return (
                                            <tr>
                                                <td colSpan="7" className="text-center py-3 text-muted">Học viên chưa tham gia buổi thực hành lâm sàng nào.</td>
                                            </tr>
                                        );
                                    }

                                    // Nhóm các bản ghi theo ngày học
                                    const groupedByDate = {};
                                    details.forEach(item => {
                                        const dateKey = item.ngayHocStr;
                                        if (!groupedByDate[dateKey]) {
                                            groupedByDate[dateKey] = [];
                                        }
                                        groupedByDate[dateKey].push(item);
                                    });

                                    // Lọc và chọn bản ghi hiển thị tối ưu nhất cho mỗi ngày
                                    const displayList = Object.keys(groupedByDate).map(dateKey => {
                                        const items = groupedByDate[dateKey];
                                        // Ưu tiên dòng có mặt ngoài lịch (TrangThai = 2)
                                        const ngoaiLich = items.find(x => x.trangThai === 2);
                                        if (ngoaiLich) return ngoaiLich;

                                        // Tiếp theo là có mặt thường (TrangThai = 1) hoặc vắng (3, 4)
                                        const thucTe = items.find(x => x.trangThai === 1 || x.trangThai === 3 || x.trangThai === 4);
                                        if (thucTe) return thucTe;

                                        // Cuối cùng nếu chỉ có dòng trung chuyển (TrangThai = 5) thì mới hiển thị dòng 5
                                        return items[0];
                                    });

                                    // Sắp xếp lại theo ngày học
                                    displayList.sort((a, b) => {
                                        const dateA = a.ngayHocStr.split('/').reverse().join('-');
                                        const dateB = b.ngayHocStr.split('/').reverse().join('-');
                                        return dateA.localeCompare(dateB);
                                    });

                                    return displayList.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="text-center text-muted">{idx + 1}</td>
                                            <td className="font-weight-bold">{item.ngayHocStr}</td>
                                            <td className="text-muted">{item.gvlsKeHoach || '-'}</td>
                                            <td className="text-dark font-weight-bold">{item.gvlsThucTe || '-'}</td>
                                            <td>
                                                <Badge bg={item.loaiHinhText === 'Ngoài kế hoạch' || item.trangThai === 2 ? 'warning' : 'light'} className="text-dark border">
                                                    {item.trangThai === 2 ? "Ngoài lịch" : item.loaiHinhText}
                                                </Badge>
                                            </td>
                                            <td>{getTrangThaiBadge(item.trangThai)}</td>
                                            <td className="text-muted">{item.lyDoDieuPhoi || '-'}</td>
                                        </tr>
                                    ));
                                })()}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" style={{ borderRadius: '6px' }} onClick={() => setShowDetailModal(false)}>
                        Đóng
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AttendanceReportTab;
